
String.prototype.indent=function(this:string, indentation:string){
	if(this==='')
		return '';
	return this.split('\n').map(v=>`${indentation}${v}`).join('\n');
}

String.prototype.matchCount=function(this:string, sv:string){
	let offset=0,count=0;
	while((offset=this.indexOf(sv,offset))>=0){
		offset+=sv.length;
		count++;
	}
	return count;
}

String.prototype.toCamelCase=function(){
	return this
		.replace(/[\s_-](.)/g,v=>v.toUpperCase())
		.replace(/[\s_-]/g, '')
		.replace(/^(.)/,v=>v.toLowerCase());
}

String.prototype.toPascalCase=function(){
	return this
		.replace(/[\s_-](.)/g,v=>v.toUpperCase())
		.replace(/[\s_-]/g, '')
		.replace(/^(.)/,v=>v.toUpperCase());
}

String.prototype.toSnakeCase=function(){
	return this
		.replace(/[a-z][A-Z]/g,v=>v.split('').join('_'))
		.replace(/\s+/g,'_')
		.replaceAll('-','_')
		.toLowerCase();
		// .replace(/[\s_-]/g, '')
		// .replace(/^(.)/,v=>v.toUpperCase());
}

// String.prototype.camelCaseToHyphen = function () {
// 	// example usage - "thisIsACamelCaseString".camelCaseToHyphen();
// 	// returns output - "this-is-a-camel-case-string"
// 	return this.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
// }
